import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toUtcDate'
})
export class ToUtcDatePipe implements PipeTransform {

    transform(date: Date, options?: Intl.DateTimeFormatOptions): string | null {
        try {
            if (!date)
                return null;

            const defaultOptions: Intl.DateTimeFormatOptions = { timeZone: 'UTC', day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
            const optionsResult = { ...defaultOptions, options };

            return Intl.DateTimeFormat('it-IT', optionsResult).format(date);
        } catch (error) {
            console.error(`Impossibile convertire la data '${date}' in UTC => `, error)
        }
    }

}
